export function isFetching(state) {
  return state.channelVideos.activeRequests !== 0;
}
